import React, { PureComponent } from "react";
import { Table } from "antd";

class StandardTable extends PureComponent {
  handleTableChange(pagination, filters, sorter) {
    this.props.onChange(pagination, filters, sorter);
  }

  render() {
    const {
      data,
      pagination,
      loading,
      columns,
      rowKey = "id",
      scrollX,
      rowSelection,
      className = "",
      ...otherProps
    } = this.props;

    const paginationProps = {
      showSizeChanger: true,
      showQuickJumper: true,
      ...pagination,
      showTotal: total => `共${total}条数据`
    };

    return (
      <div className={["TUI-Table", className].join(" ")}>
        <Table
          {...otherProps}
          scroll={{ x: !!scrollX ? scrollX : false }}
          loading={loading}
          rowKey={rowKey}
          dataSource={data}
          columns={columns}
          rowSelection={rowSelection ? rowSelection : null}
          pagination={pagination ? paginationProps : false}
          onChange={this.handleTableChange.bind(this)}
        />
      </div>
    );
  }
}

export default StandardTable;
